module.exports = __webpack_public_path__ + "media/images/official/removeanxieties_graph6-553bad382e93620490ab2d6bc2473335.png";